import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const isUpdating = () => true;

const isEnded = () => false;

export default createReducer(initialState, {
  [types.UPDATE_DEALER_REQUEST]: isUpdating,
  [types.UPDATE_DEALER_FAILURE]: isEnded,
  [types.UPDATE_DEALER_SUCCESS]: isEnded,
});
